"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React, { createRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { IconSize, Loop } from "../../icons";
import TruncatedText from "./TruncatedText";
export var TokenTheme = /* @__PURE__ */function (TokenTheme2) {
  TokenTheme2["Light"] = "light";
  TokenTheme2["Dark"] = "dark";
  return TokenTheme2;
}(TokenTheme || {});
var Token = /*#__PURE__*/function (_React$Component) {
  _inherits(Token, _React$Component);
  var _super = _createSuper(Token);
  function Token() {
    var _this;
    _classCallCheck(this, Token);
    _this = _super.apply(this, arguments);
    _this.dragLabelRef = createRef();
    _this.onDragStart = function (event) {
      if (_this.dragLabelRef.current) {
        var dragImageElement = _this.dragLabelRef.current.cloneNode(true);
        document.body.appendChild(dragImageElement);
        dragImageElement.style.position = "absolute";
        dragImageElement.style.top = "-1000px";
        event.dataTransfer.setDragImage(dragImageElement, 15, 15);
        setTimeout(function () {
          document.body.removeChild(dragImageElement);
        });
      }
      if (_this.props.onDragStart) {
        _this.props.onDragStart(event);
      }
    };
    return _this;
  }
  _createClass(Token, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        type = _this$props.type,
        theme = _this$props.theme,
        isDraggable = _this$props.isDraggable,
        onDragEnd = _this$props.onDragEnd;
      var baseClass = "kl-token kl-token--".concat(theme);
      var hasIcon = type === "list";
      var Icon = hasIcon && /* @__PURE__ */React.createElement(Loop, {
        className: "kl-token__icon",
        size: IconSize.Small,
        "aria-label": "List"
      });
      return /* @__PURE__ */React.createElement("div", {
        className: classNames(baseClass, {
          "kl-token--draggable": isDraggable,
          "kl-token--has-icon": hasIcon
        }),
        title: name,
        draggable: isDraggable,
        onDragStart: this.onDragStart,
        onDragEnd: onDragEnd
      }, Icon, /* @__PURE__ */React.createElement(TruncatedText, {
        className: "kl-token__name"
      }, name), /* @__PURE__ */React.createElement("div", {
        className: classNames(baseClass, "kl-token--dragging kl-token__hidden-drag-label", {
          "kl-token--has-icon": hasIcon
        }),
        ref: this.dragLabelRef,
        "aria-hidden": true
      }, Icon, /* @__PURE__ */React.createElement("div", {
        className: "kl-token__name"
      }, name)));
    }
  }]);
  return Token;
}(React.Component);
Token.defaultProps = {
  theme: "light" /* Light */
};

Token = __decorateClass([observer], Token);
export default Token;